var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1914_4073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 4.77431V21.6C20.9999 22.9255 19.9254 24 18.5999 24H5.4C4.07452 24 3 22.9255 3 21.6V2.4C3 1.07452 4.07452 0 5.4 0H15.802L20.9999 4.77431Z",
    fill: "url(#paint0_linear_1914_4073)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09482 19.3994V14.4994H7.92882C8.32548 14.4994 8.65448 14.5671 8.91582 14.7024C9.17715 14.8377 9.37082 15.0197 9.49682 15.2484C9.62282 15.4771 9.68582 15.7384 9.68582 16.0324C9.68582 16.3031 9.62515 16.5527 9.50382 16.7814C9.38248 17.0101 9.19115 17.1967 8.92982 17.3414C8.66848 17.4814 8.33482 17.5514 7.92882 17.5514H7.03982V19.3994H6.09482ZM7.03982 16.7884H7.87282C8.17615 16.7884 8.39315 16.7207 8.52382 16.5854C8.65915 16.4454 8.72682 16.2611 8.72682 16.0324C8.72682 15.7897 8.65915 15.6031 8.52382 15.4724C8.39315 15.3371 8.17615 15.2694 7.87282 15.2694H7.03982V16.7884ZM10.3946 19.3994V14.4994H12.2286C12.6253 14.4994 12.9543 14.5671 13.2156 14.7024C13.477 14.8377 13.6706 15.0197 13.7966 15.2484C13.9226 15.4771 13.9856 15.7384 13.9856 16.0324C13.9856 16.3031 13.925 16.5527 13.8036 16.7814C13.6823 17.0101 13.491 17.1967 13.2296 17.3414C12.9683 17.4814 12.6346 17.5514 12.2286 17.5514H11.3396V19.3994H10.3946ZM11.3396 16.7884H12.1726C12.476 16.7884 12.693 16.7207 12.8236 16.5854C12.959 16.4454 13.0266 16.2611 13.0266 16.0324C13.0266 15.7897 12.959 15.6031 12.8236 15.4724C12.693 15.3371 12.476 15.2694 12.1726 15.2694H11.3396V16.7884ZM15.8354 19.3994V15.2624H14.4004V14.4994H18.2014V15.2624H16.7734V19.3994H15.8354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1914_4073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 4.77431H16.4018C16.0704 4.77431 15.8018 4.50568 15.8018 4.17431V0L20.9996 4.77431Z",
    fill: "#FEDF89"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1914_4073",
    x: 14.0018,
    y: -0.6,
    width: 7.59824,
    height: 7.17441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1914_4073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1914_4073",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1914_4073",
    x1: 18.5,
    y1: 2,
    x2: 3.5,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABD05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1914_4073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.dd4a25de8d3956c2d2dfecab79f332b9.svg";
export { ForwardRef as ReactComponent };